var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#101010"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8863 2.94547C13.9895 5.82003 12.3946 11.6163 12.3946 15.6812V22.3636L15.7221 18.4124V15.6812C15.7221 12.4984 16.9708 9.50473 19.2405 7.2539L16.8863 2.94547ZM7.16976 2.94547C10.0664 5.82003 11.6613 11.6163 11.6613 15.6812V22.3636L8.33377 18.4124V15.6812C8.33377 12.4984 7.08521 9.50473 4.81555 7.2539L7.16976 2.94547Z",
    fill: "#FFEA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.933dca34ec6ec856ebd830c8bbdc1c86.svg";
export { ForwardRef as ReactComponent };